import { useCallback, useEffect, useMemo, useState } from 'react';
import { debounce } from '../utils/debounce.js';
export function useIsElementScrolled(scrollingRef) {
    const [isScrolledLeft, setIsScrolledLeft] = useState(false);
    const [isScrolledUp, setIsScrolledUp] = useState(false);
    const [isScrolledRight, setIsScrolledRight] = useState(false);
    const [isScrolledDown, setIsScrolledDown] = useState(false);
    const checkScroll = useCallback((el) => {
        if (!el)
            return;
        if (el.offsetWidth === el.scrollWidth) {
            setIsScrolledRight(false);
            setIsScrolledLeft(false);
            // If it's scrolled all the way to the right
        }
        else if (el.scrollWidth - el.scrollLeft - el.offsetWidth <= 5) {
            setIsScrolledRight(true);
            setIsScrolledLeft(false);
            // If it's scrolled all the way to the left
        }
        else if (el.scrollLeft === 0) {
            setIsScrolledRight(false);
            setIsScrolledLeft(true);
            // If it's scrolled in the middle
        }
        else {
            setIsScrolledRight(true);
            setIsScrolledLeft(true);
        }
        if (el.offsetHeight === el.scrollHeight) {
            setIsScrolledDown(false);
            setIsScrolledUp(false);
            // If it's scrolled all the way to the bottom
        }
        else if (el.scrollHeight - el.scrollTop - el.offsetHeight <= 5) {
            setIsScrolledDown(true);
            setIsScrolledUp(false);
            // If it's scrolled all the way to the top
        }
        else if (el.scrollTop === 0) {
            setIsScrolledDown(false);
            setIsScrolledUp(true);
            // If it's scrolled in the middle
        }
        else {
            setIsScrolledDown(true);
            setIsScrolledUp(true);
        }
    }, []);
    const debouncedCheckScroll = useMemo(() => debounce(checkScroll, 100), [checkScroll]);
    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                debouncedCheckScroll(entry.target instanceof HTMLElement ? entry.target : null);
            }
        });
        if (scrollingRef.current) {
            resizeObserver.observe(scrollingRef.current);
        }
        return () => {
            resizeObserver.disconnect();
        };
    }, [debouncedCheckScroll, scrollingRef]);
    const onScroll = useCallback((e) => checkScroll(e.currentTarget), [checkScroll]);
    return {
        onScroll,
        isScrolledLeft,
        isScrolledUp,
        isScrolledRight,
        isScrolledDown,
    };
}
//# sourceMappingURL=useIsScrolled.js.map